export interface HelpDocument {
  contentType: string;
  createdBy: string;
  createdOn: Date;
  description: string;
  documentStorageMetadataId: number;
  fileName: string;
  fileSize: number;
  location: string;
  updatedBy: string;
  updatedOn: Date;
  uploadedFileName: string;
  version: string; //Should this be a number?
  releaseNoteId?: string; // Used to link help doc to release note.
}
